module.exports = __webpack_public_path__ + "img/zwsj.1d3d1cda.png";